import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AlertItem, AlertType, Company, ComponentModal, MessageModal } from 'src/app/core/models';
import { AlertService, CompanyService, ContractGlobalService, ModalService } from 'src/app/core/services';
import { ViewCompanyComponent } from './view-company/view-company.component';
import { CreateOrUpdateCompanyComponent } from './create-or-update-company/create-or-update-company.component';
import { VerifyPermissionUrl } from '../utils/verify-permission-url';

@Component({
  selector: 'app-manage-company',
  templateUrl: './manage-company.component.html',
  styleUrls: ['./manage-company.component.sass']
})
export class ManageCompanyComponent implements OnInit {

  public loading = false;
  public searchForm: FormGroup;
  public situationsFilterList = [
    { id: 'all', name: 'Todos' },
    { id: 'enabled', name: 'Habilitado' },
    { id: 'disabled', name: 'Desabilitado' },
  ];
  public params: any = {};
  public companies: Array<Company> = [];

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private modalService: ModalService,
    private contractGlobalService: ContractGlobalService,
    public companyService: CompanyService,
    private verifyPermissionUrl: VerifyPermissionUrl
  ) { }

  async ngOnInit() {
    this.verifyPermissionUrl.execute(['ViewCompany']);
    this.loading = true;
    this.setContractGlobal();
    this.createSearchForm();
    this.loading = false;
  }

  async confirmationModal(message: { title: string; message: string }) {
    let confirmation = null;
    await this.modalService.show(new MessageModal(
      message.title, message.message, true))
      .then(() => {
        confirmation = true;
      }).catch(error => {
        confirmation = false;
      });
    return confirmation;
  }

  async enabledOrDisabledCompany(company: Company) {
    if (company.cnpj === null) {
      this.alertService.show(new AlertItem('CompanyRequiredFields', AlertType.warning, false, 5000));
      return;
    }
    company.enabled = !company.enabled;
    const data: Company = Company.parse({
      id: company.id,
      name: company.name,
      cnpj: company.cnpj,
      enabled: company.enabled,
      regionId: company.regionId,
      cityId: company.cityId,
      address: company.address,
      logo: company.logo?.split('.com/')[1]?.split('?')[0] || ''
    });
    await this.companyService.list({ id: company.id }); // <- necessário para atualizar o cache
    await this.companyService.update(data, true).then(res => {
      this.alertService.show(new AlertItem('UpdateCompanySuccess', AlertType.success));
    }).catch(err => {
      this.alertService.show(new AlertItem('UpdateCompanyError', AlertType.danger));
    });
  }

  async deleteCompany(company: Company) {
    const confirm = await this.confirmationModal({
      title: 'Remover Empresa ' + company.name,
      message: 'Tem certeza que deseja excluir a empresa ' + company.name + '?'
    });
    if (!confirm) {
      return;
    }
    this.loading = true;
    await this.companyService.delete(company.id).then(res => {
      this.alertService.show(new AlertItem('DeleteCompanySuccess', AlertType.success));
    }).catch(err => {
      this.alertService.show(new AlertItem('DeleteCompanyError', AlertType.danger, false, 5000));
    });
    this.loading = false;
  }

  setContractGlobal() {
    if (this.contractGlobalService.contracts != null) {
      this.params['contractId[in]'] = `[${this.contractGlobalService.contracts}]`;
    } else {
      delete this.params['contractId[in]'];
    }
    this.contractGlobalService.contractEvent.subscribe(event => {
      if (event != null) {
        this.params['contractId[in]'] = `[${event}]`;
      } else {
        delete this.params['contractId[in]'];
      }
    });
  }

  setCompanies(event) {
    this.companies = event;
  }

  createSearchForm() {
    this.searchForm = this.formBuilder.group({
      search: [''],
      situation: ['']
    });
    this.searchForm.valueChanges.subscribe(data => {
      this.loading = true;
      switch (data.situation) {
        case 'all':
          delete this.params.enabled;
          break;
        case 'enabled':
          this.params.enabled = true;
          break;
        case 'disabled':
          this.params.enabled = false;
          break;
      }
      if (data.search !== '') {
        const value = data.search.replaceAll('.', '').replaceAll('/', '').replaceAll('-', '');
        if (this.isNumber(value)) {
          this.params['cnpj[like]'] = `[%${value}%]`;
        } else {
          this.params['name[like]'] = `[%${value}%]`;
        }
      } else {
        delete this.params['name[like]'];
        delete this.params['cnpj[like]'];
      }
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    });
  }

  isNumber(value) {
    return !isNaN(Number(value));
  }

  handleSearch() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  convertCNPJ(cnpj) {
    if (!cnpj) {
      return;
    }
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }

  openViewModal(company) {
    this.modalService.show(new ComponentModal(ViewCompanyComponent, company)).catch(err => {
      this.ngOnInit();
    });
  }

  openCreateOrUpdateModal(editMode = false, company) {
    this.modalService.show(new ComponentModal(CreateOrUpdateCompanyComponent, {
      editMode,
      company
    })).catch(err => {
      this.ngOnInit();
    });
    document.addEventListener('searchEvent', event => {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
    });
  }

}
